import { useFocusInvalidField } from "@shared/hooks/useFocusInvalidField";
import { FormElementAttributes } from "@types";
import classNames from "classnames";
import { Field } from "formik";
import { useFormContext } from "./form-context";

interface Props extends FormElementAttributes {
  hasError?: boolean;
}

const TextAreaInput: React.FC<Props> = (props) => {
  const { commonAttrs, hasError, classes } = props;
  const { name, id, min, max, placeholder } = commonAttrs;
  const { validate } = useFormContext();
  const { fieldRef } = useFocusInvalidField(name, true);
  return (
    <Field
      name={name}
      validate={(v: any) => validate(name, v)}
      className={classNames(
        classes.join(" "),
        "form-control",
        hasError ? "form-error-validation" : ""
      )}
      id={id}
      as="textarea"
      minLength={min ? parseInt(min) : undefined}
      maxLength={max ? parseInt(max) : undefined}
      placeholder={placeholder}
      innerRef={(el: HTMLElement) => {
        fieldRef.current = el;
      }}
    />
  );
};

export default TextAreaInput;
